import { render, staticRenderFns } from "./GalleryDetail.vue?vue&type=template&id=55323c56&"
import script from "./GalleryDetail.vue?vue&type=script&lang=js&"
export * from "./GalleryDetail.vue?vue&type=script&lang=js&"
import style0 from "./GalleryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GalleryDetail.vue"
export default component.exports